export default {"src":"/_next/static/media/SLB.5c8077b5.svg","height":18,"width":18};